import React, { useState, useRef } from "react";
import { Container, Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from "../components/loader";
import { TrashCanIcon } from "../assets/icon";
import styles from "../css/createBatchDesign.module.css";
import axiosInstance from "../services/baseurl";
import { fileUploadEndPoint, createBatchEndPoint } from "../services/endpoints";

const CreateBatch = () => {
  const tokenImg = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [TIFile, setTIFile] = useState([]);
  const [tokenPrice, setTokenPrice] = useState("");
  const [batchStatus, setBatchStatus] = useState("");
  const [isImageUploadModalVisible, setIsImageUploadModalVisible] =
    useState(false);
  const [name, setName] = useState("");
  const [size, setSize] = useState("");
  const [dpi, setDpi] = useState("");
  const [note, setNote] = useState("");

  const handleTFIImageUploadModal = () => {
    setName("");
    setSize("");
    setDpi("");
    setNote("");
    setIsImageUploadModalVisible(true);
  };

  const handleClose = () => {
    setIsImageUploadModalVisible(false);
  };

  const handleName = (e) => {
    let val = e.target.value;
    setName(val);
  };
  const handleSize = (e) => {
    let val = e.target.value;
    setSize(val);
  };
  const handleDpi = (e) => {
    let val = e.target.value;
    setDpi(val);
  };
  const handleNote = (e) => {
    let val = e.target.value;
    setNote(val);
  };

  const handleTIFileUpload = () => {
    if (!name.trim() || !size.trim() || !dpi.trim() || !note.trim()) {
      toast.error("Complete the image details before choosing a file.");
      return;
    }
    tokenImg.current?.click();
  };

  const handleFileUploadApi = (file) => {
    const formData = new FormData();
    formData.append("FileData", file);
    setIsLoading(true);
    let token = sessionStorage.getItem("token");
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axiosInstance
      .post(fileUploadEndPoint, formData, { timeout: 120000 })
      .then((response) => {
        if (response.data.status === "Success") {
          let Obj = {
            id: 0,
            imageURL: response.data.payload.imageURL,
            imageId: response.data.payload.imageId,
            imageName: file.name,
            createdDate: new Date(),
            batchId: 0,
            dpi,
            note,
            size,
          };
          setTIFile((prev) => [...prev, Obj]);
          setIsLoading(false);
          setIsImageUploadModalVisible(false);
        } else {
          setIsLoading(false);
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error.message);
      });
  };

  function renameFile(originalFile, newName) {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  }

  const handleSelectedFiles = (e) => {
    const uploadedfile = e.target.files?.[0];
    if (!uploadedfile || isLoading) return;
    e.target.value = "";
    if (!/\.(png|jpe?g)$/i.test(uploadedfile.name)) {
      toast.error("Choose a PNG or JPG image.");
      return;
    }
    const extension = uploadedfile.name.split(".").pop();
    const fileName = /\.(png|jpe?g)$/i.test(name.trim())
      ? name.trim()
      : `${name.trim()}.${extension}`;
    let TIfile = renameFile(uploadedfile, fileName);
    handleFileUploadApi(TIfile);
  };

  const handleFileUploadDelete = (indkey) => {
    let filteredTIFile = TIFile.filter((item, ind) => ind !== indkey);
    if (filteredTIFile) setTIFile(filteredTIFile);
  };

  const handleTokenPrice = (e) => {
    let val = e.target.value;
    setTokenPrice(val);
  };
  const handleBatchStatus = (e) => {
    let val = e.target.value;
    setBatchStatus(val);
  };

  const handleCreateBatch = () => {
    if (isLoading) return;
    if (
      TIFile.length &&
      batchStatus &&
      Number.isFinite(Number(tokenPrice)) &&
      Number(tokenPrice) > 0
    ) {
      setIsLoading(true);
      const requestData = {
        batchId: 0,
        phoneId: "",
        logoId: "",
        drawDate: new Date(),
        winnerId: 0,
        phoneName: "",
        logoName: "",
        status: batchStatus,
        url: "",
        amount: Number(tokenPrice),
        winnerURL: "",
        images: TIFile,
      };
      let token = sessionStorage.getItem("token");
      axiosInstance.defaults.headers.common["Authorization"] =
        `Bearer ${token}`;
      axiosInstance
        .post(createBatchEndPoint, requestData)
        .then((response) => {
          if (response.data.status === "Success") {
            toast.success(response.data.message);
            setTokenPrice("");
            setBatchStatus("");
            setTIFile([]);
          } else {
            toast.error(response.data.message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          toast.error(error.message);
        });
    } else {
      toast.error(
        "Add at least one image, a positive token price, and a batch status.",
      );
    }
  };

  const statusOptions = [
    { value: "A", label: "Active", detail: "Available now" },
    { value: "P", label: "Pending", detail: "Waiting to go live" },
    { value: "C", label: "Completed", detail: "Draw finished" },
    { value: "D", label: "Deleted", detail: "Removed from sale" },
  ];
  const selectedStatus = statusOptions.find(
    (option) => option.value === batchStatus,
  );
  const canCreate =
    TIFile.length > 0 &&
    batchStatus &&
    Number.isFinite(Number(tokenPrice)) &&
    Number(tokenPrice) > 0;
  const UploadMark = () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path
        d="M12 16V4m-4 4 4-4 4 4M4 15v5h16v-5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  return (
    <Container fluid className="p-0 dashboard-glass admin-theme">
      {isLoading && <Loader />}
      <div className="admin-page">
          <main className={styles.workspace}>
            <header className={styles.pageHeader}>
              <div>
                <span className={styles.eyebrow}>YOUR COLLECTIONS</span>
                <h1>Create a new batch</h1>
                <p>
                  Bring your images together. Set a price and choose how your
                  batch starts.
                </p>
              </div>
              <span className={styles.draftBadge}>
                <span /> New batch
              </span>
            </header>
            <div className={styles.layout}>
              <section
                className={styles.panel}
                aria-labelledby="batch-images-title"
              >
                <div className={styles.sectionHeader}>
                  <div className={styles.sectionTitle}>
                    <span className={styles.step}>01</span>
                    <div>
                      <h2 id="batch-images-title">Image collection</h2>
                      <p>Add the images included in this batch.</p>
                    </div>
                  </div>
                  <span className={styles.count}>
                    {TIFile.length} {TIFile.length === 1 ? "image" : "images"}
                  </span>
                </div>
                <div className={styles.uploadArea}>
                  <span className={styles.uploadIcon}>
                    <UploadMark />
                  </span>
                  <h3>
                    {TIFile.length
                      ? "Make room for more"
                      : "Start with something beautiful"}
                  </h3>
                  <p>Add an image and its details to build your collection.</p>
                  <Button
                    type="button"
                    onClick={handleTFIImageUploadModal}
                    disabled={isLoading}
                    className={styles.primaryButton}
                  >
                    <UploadMark /> Add image
                  </Button>
                  <small>PNG or JPG images</small>
                </div>
                {TIFile.length > 0 ? (
                  <div className={styles.imageGrid}>
                    {TIFile.map((file, index) => (
                      <article
                        className={styles.imageCard}
                        key={`${file.imageId}-${index}`}
                      >
                        <div className={styles.preview}>
                          <img src={file.imageURL} alt={file.imageName} />
                          <span className={styles.imageNumber}>
                            {String(index + 1).padStart(2, "0")}
                          </span>
                        </div>
                        <div className={styles.imageInfo}>
                          <div>
                            <h3 title={file.imageName}>{file.imageName}</h3>
                            <p>
                              {file.size || "Image"}
                              {file.dpi ? ` \u00b7 ${file.dpi} DPI` : ""}
                            </p>
                          </div>
                          <Button
                            type="button"
                            className={styles.removeButton}
                            aria-label={`Remove ${file.imageName}`}
                            onClick={() => handleFileUploadDelete(index)}
                            disabled={isLoading}
                          >
                            <TrashCanIcon />
                          </Button>
                        </div>
                      </article>
                    ))}
                  </div>
                ) : (
                  <p className={styles.emptyNote}>
                    Your uploaded images will appear here, ready to review.
                  </p>
                )}
              </section>
              <aside className={styles.settings}>
                <section
                  className={styles.panel}
                  aria-labelledby="batch-settings-title"
                >
                  <div className={styles.sectionTitle}>
                    <span className={styles.step}>02</span>
                    <div>
                      <h2 id="batch-settings-title">Batch settings</h2>
                      <p>A few details before you create.</p>
                    </div>
                  </div>
                  <div className={styles.field}>
                    <label htmlFor="batch-price">
                      Token price <span>*</span>
                    </label>
                    <div className={styles.priceInput}>
                      <span aria-hidden="true">&#8377;</span>
                      <input
                        id="batch-price"
                        type="number"
                        min="0.01"
                        step="0.01"
                        inputMode="decimal"
                        placeholder="0.00"
                        value={tokenPrice}
                        onChange={handleTokenPrice}
                        disabled={isLoading}
                      />
                    </div>
                    <small>Price per token, in Indian rupees.</small>
                  </div>
                  <fieldset className={styles.statusField}>
                    <legend>
                      Batch status <span>*</span>
                    </legend>
                    <div className={styles.statusGrid}>
                      {statusOptions.map((option) => (
                        <label
                          key={option.value}
                          className={`${styles.statusOption} ${batchStatus === option.value ? styles.selected : ""}`}
                        >
                          <input
                            type="radio"
                            name="batchStatus"
                            value={option.value}
                            checked={batchStatus === option.value}
                            onChange={handleBatchStatus}
                            disabled={isLoading}
                          />
                          <span>
                            <strong>{option.label}</strong>
                            <small>{option.detail}</small>
                          </span>
                        </label>
                      ))}
                    </div>
                  </fieldset>
                </section>
                <section
                  className={`${styles.panel} ${styles.summary}`}
                  aria-label="Batch summary"
                >
                  <span className={styles.eyebrow}>AT A GLANCE</span>
                  <h2>Your batch summary</h2>
                  <dl>
                    <div>
                      <dt>Images</dt>
                      <dd>
                        {TIFile.length ? `${TIFile.length} added` : "None yet"}
                      </dd>
                    </div>
                    <div>
                      <dt>Token price</dt>
                      <dd>
                        {Number(tokenPrice) > 0 &&
                        Number.isFinite(Number(tokenPrice))
                          ? new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                            }).format(Number(tokenPrice))
                          : "Not set"}
                      </dd>
                    </div>
                    <div>
                      <dt>Status</dt>
                      <dd>{selectedStatus?.label || "Not selected"}</dd>
                    </div>
                  </dl>
                  <p>
                    Review your images and settings before creating the batch.
                  </p>
                </section>
              </aside>
            </div>
            <footer className={styles.actionBar}>
              <div>
                <strong>
                  {canCreate ? "Everything is ready" : "A little more to add"}
                </strong>
                <p>
                  {canCreate
                    ? "Your collection is ready to become a batch."
                    : "Add an image, set a price, and select a status."}
                </p>
              </div>
              <Button
                type="button"
                className={styles.primaryButton}
                disabled={!canCreate || isLoading}
                onClick={handleCreateBatch}
              >
                Create batch <span aria-hidden="true">&#8599;</span>
              </Button>
            </footer>
          </main>
        </div>
      <input
        type="file"
        ref={tokenImg}
        hidden
        aria-label="Choose batch image"
        onChange={handleSelectedFiles}
        accept=".png,.jpg,.jpeg"
      />
      <Modal
        show={isImageUploadModalVisible}
        onHide={isLoading ? undefined : handleClose}
        centered
        className={styles.imageModal}
        aria-labelledby="image-upload-title"
      >
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title id="image-upload-title">Add an image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className={styles.modalIntro}>
            Give your image a few details, then choose the file to upload.
          </p>
          <div className={styles.modalFields}>
            <div className={styles.field}>
              <label htmlFor="image-name">
                Image name <span>*</span>
              </label>
              <input
                id="image-name"
                value={name}
                onChange={handleName}
                placeholder="e.g. Mountain sunrise"
                disabled={isLoading}
              />
            </div>
            <div className={styles.metadataGrid}>
              <div className={styles.field}>
                <label htmlFor="image-size">
                  Size <span>*</span>
                </label>
                <input
                  id="image-size"
                  value={size}
                  onChange={handleSize}
                  placeholder="e.g. 1920 x 1080"
                  disabled={isLoading}
                />
              </div>
              <div className={styles.field}>
                <label htmlFor="image-dpi">
                  DPI <span>*</span>
                </label>
                <input
                  id="image-dpi"
                  value={dpi}
                  onChange={handleDpi}
                  placeholder="e.g. 300"
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className={styles.field}>
              <label htmlFor="image-note">
                Note <span>*</span>
              </label>
              <textarea
                id="image-note"
                value={note}
                onChange={handleNote}
                placeholder="A short description of your image"
                rows={3}
                disabled={isLoading}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            variant="secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className={styles.primaryButton}
            onClick={handleTIFileUpload}
            disabled={
              isLoading ||
              !name.trim() ||
              !size.trim() ||
              !dpi.trim() ||
              !note.trim()
            }
          >
            <UploadMark /> Choose image
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default CreateBatch;
